import * as React from 'react'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { PlaybackContentLink, playerConfig } from '..'
import { processDeeplinkFor } from '../../deeplink'
import { logRefTag } from './logger'
import { ClientsideLogger } from '@utils'

const logger = new ClientsideLogger('DVWebNode:deeplink')

export type OnPlay = (content: PlaybackContentLink) => void

type PlaybackAreaProps = {
  pageType: playerConfig.PageType
  onPlay: OnPlay | null
  launchType: WpsRuntime.atv.wps.DeeplinkingLaunchType
  trailerLaunchType: WpsRuntime.atv.wps.DeeplinkingLaunchType
}

type PlayCallback = {
  onPlay: OnPlay | null
}

export const PlayerContext = React.createContext<PlayCallback>({ onPlay: null })

const onPlayRouter = (
  onPlay: OnPlay,
  launchType: WpsRuntime.atv.wps.DeeplinkingLaunchType,
  trailerLaunchType: WpsRuntime.atv.wps.DeeplinkingLaunchType,
  pageType: playerConfig.PageType
) => (content: PlaybackContentLink) => {
  const launchTypeToApply =
    (content.contentConfig.videoType || '').toLowerCase() === 'trailer'
      ? trailerLaunchType
      : launchType

  const { ref } = content.contentConfig

  if (ref) {
    logRefTag(ref)
  }

  logger.count(`DVWebNode:LaunchType:${pageType}:${launchTypeToApply}`, 1, true)

  if (launchTypeToApply === 'EMBEDDED') {
    onPlay(content)
  } else if (launchTypeToApply !== 'NONE') {
    processDeeplinkFor[launchTypeToApply]({
      url: content.playbackUrl,
      fallbackUrl: content.fallbackUrl
    })
  }
}

export const PlaybackArea: React.StatelessComponent<PlaybackAreaProps> = ({
  onPlay,
  launchType,
  trailerLaunchType,
  pageType,
  children,
}) => (
  <PlayerContext.Provider
    value={{
      onPlay: onPlayRouter(onPlay, launchType, trailerLaunchType, pageType)
    }}>
    {children}
  </PlayerContext.Provider>
)
